import bg_home from 'assets/images/bg_home.png';
import HeaderMenu from 'components/Header/HeaderMenu';
import { SITE } from 'config/config';
import { useEffect, useState } from 'react';
import { getAllSetting } from 'service/base';
import { SETTING_KEYS } from 'utils/common/const';
import RuleWC from './components/RuleWC';

const RuleFixPage = () => {
  const [dataSettings, setDataSettings] = useState([]);

  useEffect(() => {
    fetchAllSetting();
  }, []);

  const fetchAllSetting = async () => {
    try {
      const res = await getAllSetting({ site: SITE });
      setDataSettings(res?.data || []);
    } catch (error) {
      console.error('Error fetching settings:', error);
    }
  };

  console.log('dataSettings', dataSettings);

  return (
    <div className="w-full h-full">
      <img
        src={bg_home}
        alt="Background"
        className="h-full w-full fixed right-0 bottom-0 object-cover"
      />
      <div className="hidden xl:block">
        <div className="fixed left-0 top-4">
          <img
            src="assets/images/match/terry1.png"
            alt="Background"
            className="w-80 h-auto object-contain"
          />
        </div>
        <div className="fixed right-0 bottom-0">
          <img
            src="assets/images/match/terry2.png"
            alt="Background"
            className="w-60 h-auto object-contain"
          />
        </div>
      </div>
      <div className="relative z-10 pb-5">
        <HeaderMenu />
        <div className="container relative z-10">
          <div
            className="mx-auto bg-white/95 border-solid border-[#26A9E0] border-[6px] rounded-3xl shadow shadow-primary p-2 md:pb-8 md:pt-4 md:px-10
                w-full"
          >
            <div
              className="w-full mt-5 rounded-[20px] border-4 border-[#26A9E0] bg-[#F2FBF3] p-6 md:px-[46px] md:py-[24px]"
              dangerouslySetInnerHTML={{
                __html: dataSettings?.find((item) => item.key === SETTING_KEYS.RULE)?.content
              }}
            />
            <RuleWC />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RuleFixPage;
